
import store from '@/store'

export  function checkPermission (val) {
    if (store.state.userInfo.userInfo.permissions['*:*:*']) { 
        // 判断用户是否是超级管理员
        return true;
    } else {
        return store.state.userInfo.userInfo.permissions && store.state.userInfo.userInfo.permissions[val];
    }
};
export default {
    inserted(el, bind, vNode) {
        let val = bind.value;
        let filedata = false;
        // console.log('dsgasgagfagaga', vNode.context.$store.state.userInfo.userInfo.permissions);
        if (vNode.context.$store.state.userInfo.userInfo.permissions['*:*:*']) { // 判断用户是否是超级管理员
            filedata = true;
        } else {
            filedata = vNode.context.$store.state.userInfo.userInfo.permissions && vNode.context.$store.state.userInfo.userInfo.permissions[val];
        }

        !filedata && el.parentNode.removeChild(el);
    },
};
